import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralFromLocation } from "@/lib/affiliateAttribution";

/**
 * Mounts inside BrowserRouter and captures any `?ref={username}` on every
 * navigation. Persistence is gated by `affiliateAttribution.ts` (validates
 * username shape, applies 30-day TTL on the localStorage record).
 */
export function ReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    captureReferralFromLocation({ search: location.search, pathname: location.pathname });
  }, [location.search, location.pathname]);
  return null;
}
